import { startMsalApp } from '@higgins/ui';
import App from './app';
import { msalInstance, API_SCOPES } from './lib/msal';
import './index.css';

// Sign in as the user the portal names (login_hint), then render (#242).
void startMsalApp({ msal: msalInstance, scopes: API_SCOPES, app: <App /> });
